import { Link } from 'react-router-dom'
import { useAuth } from 'grabbitbot-legacy-ui'

/** Port of `UserComponent` (`/user`): the legacy page only printed the
 * signed-in user's e-mail (its keep-alive loop was commented out). */
export function UserPage() {
  const { user } = useAuth()
  return (
    <div className="portal-card portal-card--profile">
      <h1>{user?.email || user?.username || ''}</h1>
      <p>
        <Link to="/connections/telegram">Telegram connection</Link> · <Link to="/logout">Log out</Link>
      </p>
    </div>
  )
}
